import React, { Fragment, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { withLocales, withClientConfig } from '@spotahome/soyuz/client';
import { localesShape, clientConfigShape } from '@spotahome/soyuz/shapes';
import { Modal, AccountNotValidatedBanner } from '@spotahome/ui-library';
import { Mediator } from '@spotahome/soyuz-mediator';
import { getLoggedInUserInfo } from '@spotahome/soyuz-auth-client';

import '@spotahome/ui-library/lib/components/Modal.css';
import '@spotahome/ui-library/lib/components/AccountNotValidatedBanner.css';

import { resendActivationUser } from '../common/api/traditional-login-client';
import { TOKEN_EXPIRED } from '../common/utils/channels';

import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

import './Header.scss';

const SESSION_EXPIRED_STATUS = 401;

async function requestLoggedInUserInfo() {
  try {
    const response = await getLoggedInUserInfo();
    return response.data.email
      ? {
          email: response.data.email,
          verified: response.data.isActivatedByEmail,
          id: response.data.id
        }
      : null;
  } catch (err) {
    if (err.response && err.response.status === SESSION_EXPIRED_STATUS) {
      Mediator.publish(TOKEN_EXPIRED);
      return null;
    }
    throw new Error(err);
  }
}

function resendLink(id) {
  try {
    resendActivationUser(id);
  } catch (err) {
    console.log(err);
  }
}

const Header = props => {
  const [isMobileOpen, setMobileOpen] = useState(false);

  const handleToggleMobileHeader = useCallback(
    () => setMobileOpen(!isMobileOpen),
    [isMobileOpen]
  );

  return (
    <Fragment>
      {props.clientConfig.featureToggle.traditionalLoginResendLink && (
        <AccountNotValidatedBanner
          getLoggedInUserInfo={requestLoggedInUserInfo}
          resendLinkCB={resendLink}
        />
      )}
      <header className="header">
        <DesktopHeader
          locales={props.locales}
          onClickMenu={handleToggleMobileHeader}
        />
        {isMobileOpen && (
          <Modal contentLabel="modal" size="fullscreen" isOpen={isMobileOpen}>
            <MobileHeader
              locales={props.locales}
              onClose={handleToggleMobileHeader}
            />
          </Modal>
        )}
      </header>
    </Fragment>
  );
};

Header.propTypes = {
  locales: PropTypes.shape(localesShape).isRequired,
  clientConfig: PropTypes.shape(clientConfigShape).isRequired
};

export default withClientConfig()(withLocales()(Header));
